/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const LifecycleStatus = zod.enum(['pending', 'active', 'served', 'revoked', 'voided']);

export type LifecycleStatus = zod.input<typeof LifecycleStatus>;
export type LifecycleStatusOutput = zod.output<typeof LifecycleStatus>;
